import { notFound } from 'next/navigation';
import { FC } from 'react';
import { ListicleBlockStoryblok } from 'storyblok-types';
import { Picture } from 'atoms/Picture';
import { H1 } from 'atoms/Typography';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { GetFFProductsParams } from 'commerce/factFinder/types';
import { getProductsByCategoryId } from 'commerce/scayle/product-management';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import { getAverageRatingMerged } from 'commerce/services/reviews';
import { IProductForAverageReviews } from 'commerce/services/reviews/types';
import {
  addAverageRatingToProducts,
  getAverageRatingForProducts,
} from 'commerce/services/reviews/utlls';
import { getSearchProductsBackend } from 'commerce/shop/backend';
import { ListicleProducts } from './ListicleProducts';
import styles from './styles.module.css';

interface ListicleBlockProps
  extends IStoryBlokComponentProps<ListicleBlockStoryblok> {
  searchParams?: { [key: string]: string | string[] | undefined };
}

export const ListicleBlock: FC<ListicleBlockProps> = async ({
  blok,
  serverProps,
}) => {
  let products: IProductForAverageReviews[] = [];

  if (!blok?.gift_finder) {
    const { response, error } = await getProductsByCategoryId({
      id: blok?.product_category,
      pagination: {
        page: 1,
        perPage: Number(blok?.number_of_products) || 10,
      },
    });

    if (error) {
      return notFound();
    }

    const averageRating = await getAverageRatingForProducts(
      response?.entities ?? [],
      getAverageRatingMerged,
    );

    products = addAverageRatingToProducts({
      products: response?.entities ?? [],
      rating: averageRating,
    }) as IAdaptedProduct[];
  } else {
    const limit = Number(blok?.number_of_products) || 10;
    const ffParams = {
      page: 1,
      hitsPerPage: limit,
      searchQuery: serverProps?.queryParams,
    } as GetFFProductsParams;
    const factFinderResult = await getSearchProductsBackend(ffParams);
    products = factFinderResult.data.hits.slice(0, limit);
  }
  return (
    <div className={styles.root}>
      {!blok?.gift_finder && (
        <>
          <Picture
            srcDesktop={blok.hero_desktop}
            srcMobile={blok.hero_mobile}
            className={styles.hero}
          />
          <H1 className={styles.title}>{blok.title}</H1>
        </>
      )}
      <ListicleProducts products={products} />
    </div>
  );
};
